/*
 * user-JWT.type.st
 *
 */
// TODO: CREATE a share lib of definitions!!!
// Reference: 1eLC-eSystem/eLC-eSystem-API/src/auth/auth.type.ts
//
export type mtJWTPayloadAccess = {
  iss: string; // issuer        : 'www.elc.com.sg'
  aud: string; // audience      : 'eLC.eSystem.API'
  sub: number; // subject       : User.cpinID
  iat: number; // issued at     : generated by JWT
  exp: number; // epiration time: 60m
  cpisUUID: string;
  cpisNameLogin: string;
  cpisNameDisplay: string;
  cpieUserType: string; //eTypeUserType;
  cpiaUserRole: string[];
};
//
export const moJWTPayloadAccessInit: mtJWTPayloadAccess = {
  iss: '',
  aud: '',
  sub: 0,
  iat: 0,
  exp: 0,
  cpisUUID: '',
  cpisNameLogin: 'eLCGuest',
  cpisNameDisplay: 'eLC Guest',
  cpieUserType: 'eGUEST', //eTypeUserType.eGUEST,
  cpiaUserRole: ['eLCGuest'], //['eLCGuest'],
};
//
// export type mtJWTPayloadRefresh = {
//   iss: string;
//   aud: string;
//   sub: number;
//   iat: number;
//   exp: number;
//   cpisUUID: string;
// };
//
// export const moJWTRefreshPayload: mtJWTPayloadRefresh = {
//   iss: '',
//   aud: '',
//   sub: 0,
//   iat: 0,
//   exp: 0,
//   cpisUUID: '',
// };
//
//#end#
